import { queryOptions, type MutationOptions } from '@tanstack/react-query'
import { api } from '@/lib/api'

async function fetchPlaybackState() {
	const response = await api.api.playback.state.get()
	if (response.error) {
		throw new Error('Failed to fetch playback state')
	}

	return response.data
}

export const playbackQueryOptions = queryOptions({
	queryKey: ['playback'],
	queryFn: fetchPlaybackState,
	staleTime: Infinity,
})

export function playMutationOptions(): MutationOptions<unknown, Error, { playlistId: string; startIndex?: number }> {
	return {
		mutationFn: async ({ playlistId, startIndex }) => {
			const response = await api.api.playback.play.post({ playlistId, startIndex })
			if (response.error) {
				throw new Error('Failed to start playback')
			}
			return response.data
		},
	}
}

export function stopMutationOptions(): MutationOptions<unknown, Error, void> {
	return {
		mutationFn: async () => {
			const response = await api.api.playback.stop.post()
			if (response.error) {
				throw new Error('Failed to stop playback')
			}
			return response.data
		},
	}
}
